import { graphql, useStaticQuery } from 'gatsby';

type SiteWideBannerQuery = {
  contentfulSiteMetadata: {
    siteWideBanner: Queries.NotificationFragmentFragment;
    siteWideBannerMobile: Queries.NotificationFragmentFragment;
  };
  referralNotification: Queries.NotificationFragmentFragment;
  affiliateNotification: Queries.NotificationFragmentFragment;
};

const useSiteWideBannerQuery = () => {
  const data = useStaticQuery<SiteWideBannerQuery>(graphql`
    query SiteWideBanner {
      contentfulSiteMetadata(slug: { eq: "site-metadata" }) {
        siteWideBanner {
          ...NotificationFragment
        }
        siteWideBannerMobile {
          ...NotificationFragment
        }
      }
      referralNotification: contentfulNotification(slug: { eq: "referral" }) {
        ...NotificationMessageFragment
      }
      affiliateNotification: contentfulNotification(slug: { eq: "affiliate" }) {
        ...NotificationMessageFragment
      }
    }
  `);

  const {
    contentfulSiteMetadata: { siteWideBanner: defaultSiteWideBanner, siteWideBannerMobile: mobileSiteWideBanner },
    referralNotification,
    affiliateNotification,
  } = data ?? {
    contentfulSiteMetadata: { defaultSiteWideBanner: {}, mobileSiteWideBanner: null },
    referralNotification: {},
    affiliateNotification: {},
  };

  return {
    defaultSiteWideBanner,
    mobileSiteWideBanner,
    referralNotification,
    affiliateNotification,
  };
};

export default useSiteWideBannerQuery;
